import sortBy from 'lodash/sortBy';
import { http } from '@/system/http';

export default {
    state: {
        treatments: [],
        filters: {
            search: '',
            status: null
        },
        statuses: {
            active: trans('apps.treatments.statuses.active'),
            complete: trans('apps.treatments.statuses.complete'),
            not_started: trans('apps.treatments.statuses.not_started'),
            expired: trans('apps.treatments.statuses.expired'),
        },
        clientId: null,
        loaded: false,
        loading: false,
    },

    getters: {
        all: (state) => state.treatments.sort((a, b) => new Date(b.start_date) - new Date(a.start_date)),

        isLoaded: (state) => state.loaded,

        isLoading: (state) => state.loading,

        statuses: (state) => state.statuses,

        active: (state) => state.treatments.filter(treatment => treatment.status === 'active'),
    },

    mutations: {
        add: (state, treatment) => {
            state.treatments.push(treatment);
        },

        update: (state, treatment) => {
            let index = state.treatments.findIndex(t => t.id === treatment.id);

            if (index >= 0) {
                state.treatments[index] = treatment;
            }
        },

        delete: (state, treatment) => {
            state.treatments = state.treatments.filter(t => t.id !== treatment.id)
        },

        setClientId: (state, clientId) => state.clientId = clientId,

        setTreatments: (state, treatments) => state.treatments = treatments,

        setLoaded: (state, loaded) => state.loaded = loaded,

        setLoading: (state, loading) => state.loading = loading,
    },

    actions: {
        loadTreatments({ state, commit, dispatch }, clientId) {
            // If the clientId is the same as the current one, and the treatments are already loaded or loading, do nothing
            if (state.clientId === clientId && (state.loaded || state.loading)) {
                return
            }

            commit('setClientId', clientId);

            dispatch('fetchTreatments')
        },

        fetchTreatments({state, commit}) {
            commit('setLoading', true);
            http.get(`/app/clients/${state.clientId}/treatments`)
                .then(({ data }) => {
                    commit('setTreatments', data);
                    commit('setLoaded', true);
                })
                .catch(({ error }) => {
                    commit('setTreatments', []);
                    commit('setLoaded', false);
                })
                .finally(() => {
                    commit('setLoading', false);
                });
        },

        addTreatment: ({ commit }, treatment) => commit('add', treatment),

        updateTreatment: ({ commit }, treatment) => commit('update', treatment),

        removeTreatment: ({ commit }, treatment) => commit('delete', treatment),
    },
}
